module.exports = __webpack_public_path__ + "img/no-data-academy.13652813.svg";